import React from 'react'
import {FcHome} from 'react-icons/fc'
import {MdContactPhone} from 'react-icons/md'
import {FcSelfServiceKiosk} from 'react-icons/fc'
import {SiAboutdotme} from 'react-icons/si'
import {MdLibraryBooks} from 'react-icons/md'
import {BsFacebook} from 'react-icons/bs'
import {AiFillTwitterCircle} from 'react-icons/ai'
import {GrInstagram} from 'react-icons/gr'
import {FaTelegramPlane} from 'react-icons/fa'
import './footer.css'

export const Footer = () => {
  return (
    <footer>
        <a href="" className="footer_logo">Mehari</a>

        <ul className="permalinks">
        <li className="footer_social"><a  href = "/#header" >Header</a></li>
      <li className="footer_social"><a  href = "/#about" >About</a></li>
      <li className="footer_social"><a  href = "/#services">Services</a></li>
      <li className="footer_social"><a  href = "/#experience"  >Experience</a></li>
      <li className="footer_social"><a  href = "/#testemonal" > Testimonials</a></li>
      <li className="footer_social"><a href ="/#contact" >Contact</a></li>
      
        </ul>
        <div className="footer_socials">
            
            <a href="https://www.facebook.com/mehari.tesfaye.334/"><BsFacebook /></a>
            <a href="http://"><AiFillTwitterCircle/></a>
            <a href="http://"><GrInstagram/></a>
            <a href="http://"><FaTelegramPlane/></a>
        </div>
        <div className="copy_right">
            <small>&copy;
                Mehari Tesfaye Fullstack developer. All rights reserved.
            </small>
        </div>
    </footer>
  )
}
